import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles({
  cellItem: (props) => ({
    flexGrow: (
      props.grow ? 1 : ''
    ),
    maxWidth: '100%',
    overflow: props.overflow,
  }),
});

export default useStyle;
